import { useEffect, useState } from 'react';
import { usersApi, UserDto } from '../services/usersService';

// מטמון ברמת המודול — רשימת הצוות נטענת פעם אחת ומשותפת לכל בוררי המשויכים בעמוד.
let staffCache: UserDto[] | null = null;
let staffPromise: Promise<UserDto[]> | null = null;

const loadStaffOnce = (): Promise<UserDto[]> => {
  if (staffCache) return Promise.resolve(staffCache);
  if (!staffPromise) {
    staffPromise = usersApi
      .getStaff()
      .then((list) => {
        staffCache = list;
        return list;
      })
      .catch((err) => {
        staffPromise = null; // מאפשר ניסיון טעינה חוזר לאחר כשל
        throw err;
      });
  }
  return staffPromise;
};

/**
 * רשימת הצוות (מנהלים + עובדים) לשיוך פריטים מתוזמנים.
 * בכשל טעינה (למשל סוכן שמקבל 403) מוחזרת רשימה ריקה — הבורר מציג רק את מי שכבר ידוע לו.
 */
export const useStaffList = (): UserDto[] => {
  const [staff, setStaff] = useState<UserDto[]>(staffCache ?? []);

  useEffect(() => {
    let mounted = true;
    loadStaffOnce()
      .then((list) => {
        if (mounted) setStaff(list);
      })
      .catch(() => {
        /* שגיאת טעינה — הבורר יישאר עם המשויכים הידועים בלבד */
      });
    return () => {
      mounted = false;
    };
  }, []);

  return staff;
};
